import type { PlpRepository, PlpApiContextParams } from '../../domain/interfaces/PlpRepository';
import {
  type ProductListingVm,
  toProductListingVm,
} from '../viewModels/plp.app.vm';
import type { RootState } from '@/app/store/store';
import type { PhysicalStoreQueryPort } from '@/shared/features/physical-store/application/interfaces/PhysicalStoreQueryPort';
import type { PhysicalStoresDetails } from '@/shared/features/physical-store/domain/models/PhysicalStoresDetails';

export type PlpService = ReturnType<typeof createPlpService>;

export interface GetPlpParams extends PlpApiContextParams {
  pageNumber?: number;
  signal?: AbortSignal;
}

export function createPlpService(
  repo: PlpRepository,
  physicalStoreRepo?: PhysicalStoreQueryPort
) {
  return {
    async getListing(params: GetPlpParams): Promise<ProductListingVm> {
      const { signal, ...listingParams } = params;
      const fetchOpts = signal ? { signal } : undefined;
      const listing = await repo.fetchListing(listingParams, fetchOpts);
      return toProductListingVm(listing);
    },

    prefetchPhysicalStoresDetails(): void {
      physicalStoreRepo?.prefetchStoresDetails();
    },

    selectPhysicalStoresDetails(state: RootState): PhysicalStoresDetails | undefined {
      return physicalStoreRepo?.selectStoresDetails(state);
    },
  };
}
